export default {"src":"/_next/static/image/src/assets/images/search.76bc3e2ce7c9d754a63cb2dd326fac1a.svg","height":24,"width":24};